import { render } from "./Numeracao.vue?vue&type=template&id=79c6cc98"
import script from "./Numeracao.vue?vue&type=script&lang=js"
export * from "./Numeracao.vue?vue&type=script&lang=js"

import "./Numeracao.vue?vue&type=style&index=0&id=79c6cc98&lang=css"

import exportComponent from "F:\\Projetos-Lefisc\\front-end\\front_retfont\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__